import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ParkingPlace } from 'src/interfaces/user-mobile/parking.interface';
import pin from 'src/assets/images/user-mobile/parking/area-pin.png';

import SettingBox from './SettingBox';

interface SettingListProps {
  isAllOn: boolean;
  parkingPlaces: ParkingPlace[];
  refetch: () => Promise<void>;
}

export default function SettingList({
  isAllOn,
  parkingPlaces,
  refetch,
}: SettingListProps) {
  const grouped = parkingPlaces.reduce<Record<string, ParkingPlace[]>>(
    (acc, cur) => {
      if (!acc[cur.area]) acc[cur.area] = [];
      acc[cur.area].push(cur);
      return acc;
    },
    {},
  );
  const sortedAreas = Object.keys(grouped).sort();
  const [closeAll, setCloseAll] = useState(false);

  useEffect(() => {
    if (!isAllOn) {
      setCloseAll(true); // 전체 OFF 시 닫기 트리거
      setTimeout(() => setCloseAll(false), 100); // 트리거 초기화
    }
  }, [isAllOn]);

  return (
    <>
      {sortedAreas.map(area => (
        <div key={area}>
          {area !== '0구역' && (
            <AreaTitle>
              <img src={pin} alt="pin" width={16} height={16} />
              <span>{area}</span>
            </AreaTitle>
          )}
          {grouped[area].map(place => (
            <SettingBox
              key={place.id}
              place={place}
              isAllOn={isAllOn}
              closeAll={closeAll}
              refetch={refetch}
            />
          ))}
        </div>
      ))}
    </>
  );
}

const AreaTitle = styled.h3`
  margin-top: 8px;
  padding: 16px 0 0 20px;
  color: var(--Font-02_black, #111);
  font-size: 22px;
  font-weight: 700;
  line-height: 34px;
  background-color: #ffffff;

  img {
    margin-right: 8px;
  }
`;
